/**
 * Generates or retrieves a persistent session ID for the current browser session.
 * Used to identify the current client in real-time events (to filter out self-triggered events).
 */
const getSessionId = () => {
  const SESSION_KEY = 'elsewhere_session_id';
  let sessionId = sessionStorage.getItem(SESSION_KEY);

  if (!sessionId) {
    sessionId = typeof crypto !== 'undefined' && crypto.randomUUID
      ? crypto.randomUUID()
      : Math.random().toString(36).substring(7);
    sessionStorage.setItem(SESSION_KEY, sessionId);
  }

  return sessionId;
};

// Export a singleton instance of the ID
export const currentSessionId = getSessionId();
